import React, { Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
// import classes from "./Landing.module.scss";
// import AuthGuard from "../AuthGuard";
// import Loader from "../components/sharedUI/Loader/Loader";
import Layout from "../components/sharedUI/Layout/Layout";
import { ComponentRoute, LoaderEle } from "../shared/SharedUtility";
const IncomeSurrogate = lazy(() => import(/* webpackChunkName: "IncomeSurrogate" */ "../components/IncomeSurrogate/IncomeSurrogate"));
const AccountAggregatorStatus = lazy(() => import(/* webpackChunkName: "accountAggregatorStatus" */"../components/IncomeSurrogate/AccountAggregatorStatus/AccountAggregatorStatus"));
const PosStatus = lazy(() => import(/* webpackChunkName: "PosStatus" */"../components/IncomeSurrogate/PosStatus"));
const BankAccount = lazy(() => import(/* webpackChunkName: "BankAccount" */ "../components/PenyDrop/Account/Account"));
const CityView = lazy(() => import(/* webpackChunkName: "CityScreen" */ "../components/CityView/CityView"));
const Credit = lazy(() => import(/* webpackChunkName: "CreditSuccess" */ "../components/PenyDrop/CreditSuccess/CreditSuccess"));
const Debit = lazy(() => import(/* webpackChunkName: "DebitScreen" */ "../components/PenyDrop/Debit/Debit"));
const DigiConsent = lazy(() => import(/* webpackChunkName: "DigiConsent" */ "../components/DigiLocker/DigiConsent"));
const EmailView = lazy(() => import(/* webpackChunkName: "EmailScreen" */ "../components/EmailView/EmailView"));
const GenderView = lazy(() => import(/* webpackChunkName: "GenderScreen" */ "../components/GenderView/GenderView"));
const LandingPage = lazy(() => import(/* webpackChunkName: "LandingPage" */ "../components/LandingPage/LandingPage"));
const OfficeAddress = lazy(() => import(/* webpackChunkName: "OfficeAddress" */ "../components/OfficeAddress/OfficeAddress"));
const OtpView = lazy(() => import(/* webpackChunkName: "Otp" */ "../components/OtpView/OtpView"));
const PanView = lazy(() => import(/* webpackChunkName: "PanCardScreen" */ "../components/PanView/PanView"));
const PersonalDetails = lazy(() => import(/* webpackChunkName: "PersonalDetails" */ "../components/PersonalDetails/PersonalDetails"));
const PenyDrop = lazy(() => import(/* webpackChunkName: "PennyDropStart" */ "../components/PenyDrop/index"));
const PenyFailure = lazy(() => import(/* webpackChunkName: "DebitFail" */ "../components/PenyDrop/DebitFailure/DebitFailure"));
const PenySuccess = lazy(() => import(/* webpackChunkName: "DebitSuccess" */ "../components/PenyDrop/DebitSuccess/DebitSuccess"));
const ProfessionalDetails = lazy(() => import(/* webpackChunkName: "ProfessionalDetails" */ "../components/ProfessionalDetails/ProfessionalDetails"));
const ffnNo = lazy(() => import(/* webpackChunkName: "ffnNoScreen" */ "../components/ChangeCard/Changeffno"));
const ResiAddress = lazy(() => import(/* webpackChunkName: "ResiAddress" */ "../components/DigiLocker/ResiAddress/ResiAddress"));
const ValidateOTP = lazy(() => import(/* webpackChunkName: "ValidateOtp" */ "../components/MitMidc/ValidateOTP/ValidateOTP"));
const TakePhoto = lazy(() => import(/* webpackChunkName: "TakePhoto" */ "../components/TakePhoto/TakePhoto"));
const CADScreen = lazy(() => import(/* webpackChunkName: "ResiAddress" */ "../components/DigiLocker/CADScreen/CADScreen"));
const VkycOptionScreen = lazy(() => import(/* webpackChunkName: "VkycOptionScreen" */ "../components/VKYC/VkycOptionScreen/VkycOptionScreen"));
const TelcoValidateOTP = lazy(() => import(/* webpackChunkName: "TelcoValidateOtp" */ "../components/Telco/TelcoOTPCollection"));
const GstOptionScreen = lazy(() => import(/* webpackChunkName: "IncomeSurrogateGstOption" */ "../components/IncomeSurrogate/GstOptionScreen"));
const EpfoValidateOTP = lazy(() => import(/* webpackChunkName: "EpfoValidateOtp" */ "../components/IncomeSurrogate/EpfoOTPCollection"));
const Landing = (props) => {
  const { cardName } = useParams();
  const state = useSelector((state) => state.AppNav);
  const goTo = state && state.goTo ? state.goTo : "landingPage";
  // cardName can be used to call api

  const switchTabs = () => {
    switch (goTo) {
      case "otpview":
        return ComponentRoute(OtpView, cardName);
      case "city":
        return ComponentRoute(CityView, cardName);
      case "pan":
        return ComponentRoute(PanView, cardName);
      case "email":
        return ComponentRoute(EmailView, cardName);
      case "officeaddress":
        return ComponentRoute(OfficeAddress, cardName);
      case "professional":
        return ComponentRoute(ProfessionalDetails, cardName);
      case "Changeffno":
        return ComponentRoute(ffnNo, cardName);
      case "resiaddress":
        return ComponentRoute(ResiAddress, cardName);
      case "digiConsent":
        return ComponentRoute(DigiConsent, cardName);
      case "gender":
        return ComponentRoute(GenderView, cardName);
      case "landingPage":
        return ComponentRoute(LandingPage, cardName, true);
      case "penydrop":
        return ComponentRoute(PenyDrop, cardName);
      case "account":
        return ComponentRoute(BankAccount, cardName);
      case "debit":
        return ComponentRoute(Debit, cardName);
      case "credit":
        return ComponentRoute(Credit, cardName);
      case "penySuccess":
        return ComponentRoute(PenySuccess, cardName);
      case "penyFailure":
        return ComponentRoute(PenyFailure, cardName);
      case "validateOTP":
        return ComponentRoute(ValidateOTP, cardName);
      case "takePhoto":
        return ComponentRoute(TakePhoto, cardName);
      case "CADScreen":
        return ComponentRoute(CADScreen, cardName);
      case "vkycOptionScreen":
        return ComponentRoute(VkycOptionScreen, cardName);
      case "telcoValidateOTP":
        return ComponentRoute(TelcoValidateOTP, cardName);  
      case "incomeSurrogate":
        return ComponentRoute(IncomeSurrogate,cardName);
      case "accountAggregatorStatus":
          return ComponentRoute(AccountAggregatorStatus,cardName);
      case "posStatus":
          return ComponentRoute(PosStatus,cardName);
      case "epfoValidateOTP":
        return ComponentRoute(EpfoValidateOTP, cardName);
      case "GstOptionScreen":
          return ComponentRoute(GstOptionScreen, cardName);  
      default:
        return (
          <Suspense fallback={LoaderEle}>
            <PersonalDetails cardName={cardName} />
          </Suspense>
        );
    }
  };
  return <Layout cardName={cardName}>{switchTabs()}</Layout>;
};

export default Landing;
